import { AdScheduledEvent, AdScheduledEventInit } from 'common/types'
import { EdgeClient } from 'common/generated/edgeClient'

export class AdScheduledEventsApi {
  constructor(private readonly edgeClient: EdgeClient) {}

  async createAdScheduledEvent(eventInit: AdScheduledEventInit): Promise<AdScheduledEvent[]> {
    return this.edgeClient.createAdScheduledEvent(eventInit)
  }
}
